import { useNavigate } from 'react-router-dom';
import { RecruitEmailVerification } from './RecruitEmailVerification';
import { BrandedHeader } from './BrandedHeader';
import { ComplianceFooter } from './ComplianceFooter';
import { SecureUploadCompanyProfileStatus } from './SecureUploadCompanyProfileStatus';
import { useCompanyProfile } from '@/hooks/useCompanyProfile';

export const RecruitVerification = () => {
  const navigate = useNavigate();
  const { companyProfile, loading, error, retry } = useCompanyProfile();
  if (loading || error || !companyProfile) {
return <SecureUploadCompanyProfileStatus loading={loading} onRetry={retry} />;
}
  return <div className="h-screen overflow-y-auto flex flex-col bg-[#F8F7F3] text-[#0E3A2B]">
    <BrandedHeader title="Document uploads" subtitle="Verify your saved email to continue" companyProfile={companyProfile} />
    <main className="flex-1 flex items-center justify-center px-4 py-8">
      <section className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-5 sm:p-8 shadow-sm" aria-labelledby="recruit-verification-heading">
        <h1 id="recruit-verification-heading" className="text-2xl font-semibold mb-3">Verify your email</h1>
        <p className="text-sm text-slate-600 mb-6">Use your email code, or enter your NMLS number to request one at your saved email.</p>
        <RecruitEmailVerification onVerified={async () => {
 sessionStorage.removeItem('uploadSession'); navigate('/secureuploads/recruit/upload');
}} onCancel={() => navigate('/secureuploads')} />
      </section>
    </main>
    <ComplianceFooter companyProfile={companyProfile} />
  </div>;
};
